// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linker p a{--tw-text-opacity:1;color:rgb(147 147 147 / var(--tw-text-opacity))}.linker p a:hover{--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity))}.showanimation{-webkit-animation:initanim 1s;animation:initanim 1s}@-webkit-keyframes initanim{0%{bottom:-100%}to{bottom:1rem}}@keyframes initanim{0%{bottom:-100%}to{bottom:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
